import Head from 'next/head'
import 'regenerator-runtime/runtime'
import DiscoverButton from '../../components/DiscoverButton/DiscoverButton'
import MobileAppPopup from '../../components/MobileAppPopup'
import { getPrerenderedUserInfo } from '../../queries/users'
import Profile from '../../routes/Profile/Profile'

const Routes = ({ user }) => {
  const userName = user?.uniqueDisplayName || 'User Profile'
  const userBio = user?.aboutMe || 'See user profile at DecorMatters'

  return (
    <>
      <Head>
        <title>{`@${userName} – DecorMatters`}</title>
        <meta name="description" content={userBio} />
        <meta name="twitter:site" content="www.decormatters.com" />
        <meta name="twitter:title" content={`@${userName} – DecorMatters`} />
        {user?.objectId && <meta property="og:url" content={`https://www.decormatters.com/dm/${user?.objectId}`} />}
        <meta property="og:title" content={`@${userName} – DecorMatters`} />
        <meta property="og:description" content={userBio} />
      </Head>
      <Profile />
      <MobileAppPopup />
      <DiscoverButton />
    </>
  )
}

export default Routes

export async function getServerSideProps({ query, req, res }) {
  try {
    const user = await getPrerenderedUserInfo(query.userId)

    res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=59')

    return {
      props: {
        user: user?.result?.user
      }
    }
  } catch (error) {
    return {
      props: {}
    }
  }
}
